module.exports = __webpack_public_path__ + "static/media/Scikit_learn_logo.svg.cabea0c7.png";